
import { NgModule } from '@angular/core';
import { ToastComponent } from './toast.component';
import { ToastService } from './toast.service';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
	imports:[
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule
	],
	declarations: [
		ToastComponent
	],
	providers:[
		ToastService
	],
	exports:[ToastComponent]
})
export class ToastModule { }
